export default __webpack_public_path__ + "static/kinga_alingua-scaled-cffacff56e7ba0c68798f5b682fee4f1.jpg";